import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { UnloggedLayout } from '../UnloggedLayout';
import { useFirebaseAuth } from 'src/contexts/AuthContext/FirebaseAuthContext';
import { Loading } from '../Loading';

export const FirebaseUserGuard = () => {
  const user = useFirebaseAuth();
  const location = useLocation();

  if (!user || user.loading) {
    return (
      <UnloggedLayout>
        <div className="flex items-center justify-center">
          <Loading />
        </div>
      </UnloggedLayout>
    );
  }

  if (!user.uid) {
    const params = new URLSearchParams(location.search);
    const invitedOrgId = params.get('organizationId');
    if (location.pathname === '/change-organization' && invitedOrgId) {
      return (
        <Navigate
          to={`/signup?organizationId=${encodeURIComponent(invitedOrgId)}`}
          replace
        />
      );
    }
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};
